import styled, { css } from "styled-components"

const StyledCaption = styled.figcaption`
  font-size: calc(1.5 * var(--text-size));
  font-family: var(--font-serif);
  line-height: 1.4;
  margin: 0;
  max-width: 18em;

  font-size: var(--text-size);
  font-family: var(--font-caption);
  font-weight: 500;

  font-family: var(--font-sans);
  font-weight: normal;

  font-family: var(--font-serif);
  font-size: var(--text-size-large);
  font-weight: 400;
  line-height: 1.3;

  ${props => props.textAlign && css`
    text-align: ${props.textAlign};
  `}
`;

export default StyledCaption;